<template>
    <v-card>
        <v-card-title>Saved Jobs</v-card-title>
        <template v-if="!loading">
            <v-card-text>
            <template v-if="jobs && jobs.data && jobs.data.length">
                <JobCard :key="j.id" v-for="j in jobs.data" :job="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 

                @toggleComponentLogin="toggleComponentLogin($event)">
                </JobCard>
                <br/><br/>
                <Pagination :isJSON="true" v-if="jobs && jobs.links" :links="jobs.links" @pageClick="pageClicked($event)"></Pagination>
            </template>
            <template v-else>
                No saved jobs.
                </template>
        </v-card-text>  
        </template>
        <template v-if="loading">
            <v-card-text class="text-center justify-center" min-height="300">
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
                ></v-progress-circular>
            </v-card-text>
        </template>
    </v-card>
</template>

<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import JobCard from '@/Shared/JobCard'
  import axios from 'axios'
  import Pagination from '@/Shared/Pagination'


  export default {
    props: {
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      JobCard,
      Pagination
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            expandSearch: false,
            loading:false,
            jobs:null,
            currentPage:1
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.getFavorites({});
    },
    methods: {
        getFavorites(data) {
            this.loading=true;
            var vm=this;
            if (!data || !data.label)
                data.job_page = 1;
            else if (data.label == 'Next &raquo;')
                data.job_page = this.currentPage+1;
            else if (parseInt(data.label))
                data.job_page = data.label;
            else
                data.job_page = this.currentPage-1;

            axios.get(this.baseurl+'/favorite/jobs',{ params:data }).then(function (result){
                console.log('got favorite jobs',result)
                vm.jobs = result.data;
                
                vm.currentPage = data.job_page;
                vm.loading=false;
            })
            .catch(function (e) { console.log('error',e)}) 
        },
        pageClicked(e) {
            console.log('page clicked',e)
            this.getFavorites(e);
        },
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
    },
  }
  </script>